import { useEffect, useState } from 'react';
import { getCaseDetail } from 'api/textVisit';
import { getTextVisitCaseDetail } from 'api/operation/textVisitCase';
import { TextVisitCase } from 'types/textVisit';
import { TTextVisitCaseDetailItem } from 'types/textVisitCase';

interface IUseGetCaseDetailProps {
    caseUuid?: string;
    isOps?: boolean;
    overrideProviderId?: number | string;
}

export default function useGetCaseDetail(
    props: IUseGetCaseDetailProps,
): [TextVisitCase | undefined, boolean, (caseUuid: string) => void] {
    const [loading, setLoading] = useState(false);
    const [caseDetail, setCaseDetail] = useState<TextVisitCase>();

    const fetchData = async (caseUuid: string) => {
        //todo remove
        // setCaseDetail(
        //     {
        //         "id": 96,
        //         "textVisitUuid": "TV20251126MIFDLB31QVNJ4",
        //         "klarityUserId": 106,
        //         "clientId": 106692,
        //         "patientFirstName": "Xiaocong",
        //         "patientLastName": "Liu",
        //         "patientGender": "",
        //         "patientBirthday": "1990-12-12",
        //         "patientAge": 35,
        //         "patientIdFrontUrl": null,
        //         "patientIdBackUrl": null,
        //         "state": "CA",
        //         "conditions": "Addiction",
        //         "paymentStatus": "SUCCEEDED",
        //         "idVerified": false,
        //         "patientSubmitAt": "2025-11-26T02:18:34",
        //         "providerTreatmentSubmitted": false,
        //         "providerTreatmentSubmittedAt": null,
        //         "status": "ACTIVE",
        //         "updatedAt": "2025-12-08T03:01:01",
        //         "assignedProviderId": 1446,
        //         "assignedProviderFirstName": "Xiaocong",
        //         "assignedProviderLastName": "Liu",
        //         "assignedProviderPhoto": "https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/7fdfcdfc-8dd1-414c-88db-a7d7d44ecc13.png",
        //         "assignedProviderAt": "2025-12-03T02:30:18",
        //         "summary": null,
        //         "aiSummary": "Patient Xiaocong Liu expresses concern about symptoms and seeks advice on treatment options. Lives in California.",
        //         "aiSummaryContextMd5": "4bbb3a6c469f4c3cab0b12ae62dd20ce",
        //         "aiSummaryGenerateAt": "2025-11-26T02:18:56",
        //         "aiTags": "Consultation request,Lives in California",
        //         "historyMedical": [
        //             "ADHD",
        //             "Weight loss"
        //         ],
        //         "currentMedications": [
        //             "Zoloft (sertraline)",
        //             "Wellbutrin (bupropion)",
        //             "Lexapro (escitalopram)",
        //             "Strattera (atomoxetine)",
        //             "Intuniv (guanfacine ER)",
        //             "aaa"
        //         ],
        //         "allergies": [
        //             "alpha-keto-beta-methylvaleric acid"
        //         ],
        //         "conditionHealth": {
        //             "klarityUserId": null,
        //             "notSure": false,
        //             "featured": [
        //                 "ADHD",
        //                 "Weight loss"
        //             ],
        //             "specialty": [
        //                 {
        //                     "specialtyName": "Psychiatric & Mental Health",
        //                     "conditionName": "ADHD"
        //                 },
        //                 {
        //                     "specialtyName": "Weight Loss",
        //                     "conditionName": "Weight loss"
        //                 }
        //             ]
        //         },
        //         "medicationHealth": {
        //             "notTaking": false,
        //             "medications": [
        //                 "Zoloft (sertraline)",
        //                 "Wellbutrin (bupropion)",
        //                 "Lexapro (escitalopram)",
        //                 "Strattera (atomoxetine)",
        //                 "Intuniv (guanfacine ER)"
        //             ],
        //             "others": [
        //                 "aaa"
        //             ]
        //         },
        //         "allergyHealth": {
        //             "hasAllergy": true,
        //             "allergies": [
        //                 {
        //                     "allergyType": "0",
        //                     "allergyId": "14399",
        //                     "routedMedId": "0",
        //                     "descr": "alpha-keto-beta-methylvaleric acid"
        //                 }
        //             ]
        //         },
        //         "followUps": null,
        //         "treatmentPlan": null,
        //         "intakeQuestions": [
        //             {
        //                 "id": 415,
        //                 "textVisitId": 96,
        //                 "questionType": "intake",
        //                 "fullQuestionName": "Select the state you live in",
        //                 "shortQuestionName": "Select the state you live in",
        //                 "answer": "[\"CA\"]",
        //                 "sort": 1,
        //                 "createdAt": "2025-11-26T02:18:34",
        //                 "updatedAt": "2025-11-26T02:18:34"
        //             }
        //         ],
        //         "currentWeightAndHeight": null,
        //         "weightLossGoal": null,
        //         "visitGoal": null,
        //         "providerEligible": null,
        //         "payoutAmount": 20.00,
        //         "serviceType": "INITIAL_VISIT",
        //         "patientAdditionalComment": "Hi, I’d like to discuss my symptoms and get your advice on possible treatment options. Thank you.",
        //         "prescriptions": null,
        //         "prospect": null,
        //         "assessmentName": null,
        //         "icon": null,
        //         "phone": "3828394138",
        //         "homeAddress": {
        //             "zipCode": null,
        //             "address": null,
        //             "city": null,
        //             "state": null
        //         },
        //         "pharmacy": {
        //             "ncpDpId": "0000117",
        //             "zipCode": "35749",
        //             "name": "John Spartan Pharmacy",
        //             "address": "117 Reach Rd  ",
        //             "city": "Harvest",
        //             "state": "AL",
        //             "phone": "2565551212"
        //         },
        //         "pharmacySelected": true
        //     }
        // )
        try {
            setLoading(true);
            setCaseDetail(undefined);
            // 根据 isOps 参数调用不同的接口
            if (props.isOps) {
                // 运营端调用新接口
                const result = await getTextVisitCaseDetail(caseUuid);
                if (!result.error) {
                    setCaseDetail(result?.data?.data);
                }
            } else {
                // 医生端调用原有接口
                const result = await getCaseDetail(caseUuid, props.overrideProviderId);
                if (!result.error) {
                    const data: TextVisitCase = result?.data?.data;
                    if (data) {
                        setCaseDetail(data);
                    }
                }
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (props.caseUuid) {
            fetchData(props.caseUuid);
        }
    }, [props.caseUuid, props.isOps, props.overrideProviderId]);

    return [caseDetail, loading, fetchData];
}
